export const categoryEndpoints = {
  list: '/categories',
} as const

export const CATEGORY_LIST_KEY = ['categoryList'] as const

// Salt-okunur proxy → yalnızca genel/erişim hataları. (CRUD/senkron kalktı.)
export const categoryBackendErrors = {
  GENERAL_ERROR: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  CATEGORY_NOT_FOUND: 'Kategori bulunamadı.',
} as const
